import { CreateWorkspaceLoaderProvider } from "@web-src/modules/entities/components/CreateWorkspaceLoader/CreateWorkspaceLoaderProvider";
import { FeaturesShowcaseModalProvider } from "@web-src/modules/entities/components/FeaturesShowcaseModal/FeaturesShowcaseModalProvider";
import { DeleteAccountDialogProvider } from "@web-src/modules/auth/components/DeleteAccountDialog/DeleteAccountDialogProvider";
import { ManageWorkspaceAdminProvider } from "@web-src/modules/auth/components/ManageWorkspaceAdminsDialog/ManageWorkspaceAdminProvider";
import { CXSignupDialogProvider } from "@web-src/modules/cx/components/CXSignupDialog/CXSignupDialogProvider";
import { RateLimitHandler } from "@web-src/features/api/RateLimitHandler";
import { GlobalComponentsContext } from "./GlobalComponentsContext";

export const GlobalComponentsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <GlobalComponentsContext.Provider value={undefined}>
      <CreateWorkspaceLoaderProvider>
        <FeaturesShowcaseModalProvider>
          <ManageWorkspaceAdminProvider>
            <DeleteAccountDialogProvider>
              <CXSignupDialogProvider>
                <RateLimitHandler />
                {children}
              </CXSignupDialogProvider>
            </DeleteAccountDialogProvider>
          </ManageWorkspaceAdminProvider>
        </FeaturesShowcaseModalProvider>
      </CreateWorkspaceLoaderProvider>
    </GlobalComponentsContext.Provider>
  );
};
